document.addEventListener('DOMContentLoaded', () => {
    const servicePricesTable = document.querySelector('.js-service-prices-table');

    if (servicePricesTable) initServicePricesTable();

    function initServicePricesTable() {
        servicePricesTable.addEventListener('click', ({target}) => {
            const head = target.closest('.table-head');

            if (head) {
                const body = head.nextElementSibling;
                let startHeight = body.offsetHeight, finishHeight = 0;

                head.classList.toggle('is-active');

                if (head.classList.contains('is-active')) {
                    finishHeight = body.offsetHeight;
                }

                body.animate([{height: `${startHeight}px`}, {height: `${finishHeight}px`}], {duration: 400});
            }
        });
    }
});
